import { useNavigate } from "react-router-dom";
import qStyles from "./quicklink.module.scss";

import classNames from "classnames";
export const QuickLinkItem = ({
  icon,
  title,
  description,
  link,
  rightIcon,
  className,
  documents,
}) => {
  const navigate = useNavigate();
  const titleClass = classNames("semibold", "size-14", "epnb");
  const descriptionClass = classNames("semibold", "size-12", "epnd");
  const rIcon = rightIcon ? rightIcon : "LeftArrow";
  const iconClass = classNames(`tg-icons-${rIcon}`, "size-18");

  const itemContainerClass = classNames(
    qStyles.itemContainer,
    qStyles[className] ? qStyles[className] : className
  );

  const onClick = () => {
    if (documents === true) {
      window.open(link, "_blank");
    } else {
      navigate(link);
    }
  };

  return (
    <div className={itemContainerClass} onClick={onClick}>
      <div className={qStyles.innerAlign}>
        {icon ? (
          <div className={qStyles.sectionIcon}>
            <i className={`tg-icons-${icon} size-16`}></i>
          </div>
        ) : null}
        <div className={qStyles.section}>
          <h3 className={titleClass}>{title}</h3>
          <p className={descriptionClass}>{description}</p>
        </div>
      </div>
      <button type="button">
        <i className={iconClass}></i>
      </button>
    </div>
  );
};
